import { Link } from "react-router-dom";
import { Instagram, Music, Youtube } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function Footer() {
  const { t, lang } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer
      className="relative border-t border-white/5 bg-black"
      data-testid="footer"
    >
      <div className="container-sv py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="md:col-span-5">
            <Link to="/" className="inline-block group" data-testid="footer-logo">
              <img
                src="/brand/seoulvibes-logo.png?v=2"
                alt="SeoulVibes"
                className="h-16 w-auto"
                style={{ filter: "drop-shadow(0 0 18px rgba(236,72,153,0.5))" }}
              />
            </Link>
            <p className="mt-6 text-white/55 max-w-md font-body">
              {t.footer.tagline}
            </p>
            <p className="mt-3 font-display uppercase tracking-[0.25em] text-xs text-white/40">
              {lang === "en"
                ? "Dance. Sing. Scream. Repeat."
                : "Tancuj. Zpívej. Křič. Opakuj."}
            </p>
          </div>

          {/* Links */}
          <div className="md:col-span-3">
            <h4 className="font-display uppercase tracking-[0.3em] text-[10px] text-white/40 mb-4">
              {lang === "en" ? "Explore" : "Prozkoumat"}
            </h4>
            <ul className="space-y-2.5 font-body text-white/70">
              <li>
                <Link to="/events" className="hover:text-neon-purple transition-colors" data-testid="footer-link-events">
                  {t.nav.events}
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="hover:text-neon-purple transition-colors" data-testid="footer-link-gallery">
                  {t.nav.gallery}
                </Link>
              </li>
              <li>
                <Link to="/ambassadors" className="hover:text-neon-purple transition-colors" data-testid="footer-link-merch">
                  {t.nav.merch}
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-neon-purple transition-colors" data-testid="footer-link-about">
                  {t.nav.about}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-neon-purple transition-colors" data-testid="footer-link-contact">
                  {t.nav.contact}
                </Link>
              </li>
            </ul>
          </div>

          {/* Cities */}
          <div className="md:col-span-2">
            <h4 className="font-display uppercase tracking-[0.3em] text-[10px] text-white/40 mb-4">
              {lang === "en" ? "Cities" : "Města"}
            </h4>
            <ul className="space-y-2.5 font-body text-white/70">
              <li>Prague</li>
              <li>Brno</li>
              <li>Bratislava</li>
            </ul>
          </div>

          {/* Social */}
          <div className="md:col-span-2">
            <h4 className="font-display uppercase tracking-[0.3em] text-[10px] text-white/40 mb-4">
              {t.footer.followUs}
            </h4>
            <div className="flex gap-3">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                data-testid="social-instagram"
                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white/70 hover:text-white hover:border-purple-400/60 hover:bg-purple-500/10 transition-all"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href="https://tiktok.com"
                target="_blank"
                rel="noreferrer"
                aria-label="TikTok"
                data-testid="social-tiktok"
                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white/70 hover:text-white hover:border-pink-400/60 hover:bg-pink-500/10 transition-all"
              >
                <Music className="w-4 h-4" />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noreferrer"
                aria-label="YouTube"
                data-testid="social-youtube"
                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white/70 hover:text-white hover:border-blue-400/60 hover:bg-blue-500/10 transition-all"
              >
                <Youtube className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-white/35 text-xs font-body">
            © {year} SeoulVibes. {t.footer.rights}.
          </p>
          <p className="text-white/35 text-[10px] uppercase tracking-[0.3em] font-display">
            CZ · SK · KR
          </p>
        </div>
      </div>
    </footer>
  );
}
